import { TRUCKER_PROFILE_URL } from '@/constants';
import { ForbiddenError, NotFoundError, UnauthorizedError, UnexpectedError } from '@/services';
import { HttpStatusCode, fromRiskBff, httpClient } from '@/utils';
import { LoadTruckerProfileServicePayload, TruckerProfileServiceResult } from './types';
import { parseResultToFormTrucker, validateFormTruckerData } from '@/services/utils';
import { FormTrucker } from '@/types';

export const loadTruckerProfileService = async (data: LoadTruckerProfileServicePayload): Promise<FormTrucker> => {
  const uri = fromRiskBff(TRUCKER_PROFILE_URL);
  const { body, status } = await httpClient.post<TruckerProfileServiceResult>(uri, data);

  switch (status) {
    case HttpStatusCode.ok:
      return validateFormTruckerData(
        parseResultToFormTrucker({ ...body.data, cpf: data.cpf, cellPhone: data.cellPhone }),
      );

    case HttpStatusCode.notFound:
      throw new NotFoundError();

    case HttpStatusCode.unauthorized:
      throw new UnauthorizedError();

    case HttpStatusCode.forbidden:
      throw new ForbiddenError();

    default:
      throw new UnexpectedError();
  }
};
